import axios from "axios";

export default {
  data() {
    return {
      authorizeFormList: []
    };
  },

  methods: {
    getModeratedOperationStateKey(state, finished) {
      switch (state) {
        case "IN":
          return "in";
        case "PA":
          return "pa";
        case "PV":
          return "pv";
        case "RJ":
          return "rj";
        case "VD":
          return "vd";
        case "PC":
          return finished ? "fn" : "pc";
        default:
          return null;
      }
    },
    getModeratedOperationText(state, finished, textVariant = "state") {
      const stateKey = this.getModeratedOperationStateKey(state, finished);
      if (!stateKey) {
        return "ERROR";
      }
      const translationRoot =
        textVariant === "userfriendly" ? "userfriendlyState" : "state";
      return this.$t(`${translationRoot}.${stateKey}`);
    },
    getModeratedOperationProgressValue(state, finished) {
      switch (this.getModeratedOperationStateKey(state, finished)) {
        case "in":
        case "pa":
          return 0;
        case "pv":
          return 1;
        case "vd":
          return 2;
        case "pc":
          return 3;
        case "fn":
        case "rj":
          return 4;
        default:
          return 0;
      }
    },
    getModeratedOperationVisualColor(state, finished, authorized) {
      switch (state) {
        case "IN":
        case "PA":
          return "#9e9e9e";
        case "PV":
          return "#fb8c00";
        case "RJ":
          return "var(--v-error-base)";
        case "VD":
          return "#7cb342";
        case "PC":
          return finished || authorized === true ? "#43a047" : "#1e88e5";
        default:
          return "#9e9e9e";
      }
    },
    getModeratedOperationVisualBgColor(state, finished, authorized) {
      switch (state) {
        case "IN":
        case "PA":
          return "rgba(158, 158, 158, 0.12)";
        case "PV":
          return "rgba(251, 140, 0, 0.14)";
        case "RJ":
          return "rgba(220, 53, 69, 0.12)";
        case "VD":
          return "rgba(124, 179, 66, 0.14)";
        case "PC":
          return finished || authorized === true
            ? "rgba(67, 160, 71, 0.14)"
            : "rgba(30, 136, 229, 0.12)";
        default:
          return "rgba(158, 158, 158, 0.12)";
      }
    },
    getModeratedOperationVisualBorderColor(state, finished, authorized) {
      switch (state) {
        case "IN":
        case "PA":
          return "rgba(158, 158, 158, 0.28)";
        case "PV":
          return "rgba(251, 140, 0, 0.22)";
        case "RJ":
          return "rgba(220, 53, 69, 0.24)";
        case "VD":
          return "rgba(124, 179, 66, 0.22)";
        case "PC":
          return finished || authorized === true
            ? "rgba(67, 160, 71, 0.22)"
            : "rgba(30, 136, 229, 0.22)";
        default:
          return "rgba(158, 158, 158, 0.28)";
      }
    },
    getUserfriendlyColor(state, finished, authorized, form_name) {
      switch (state) {
        case "IN":
          return "grey";
        case "PA":
          return "blue";
        case "PV":
          return "blue";
        case "RJ":
          return "red";
        case "VD":
          return "lime";
        case "PC":
          if (this.authorizeFormList.includes(form_name)){
            if(authorized !== null && finished){
              return "green"
            }else{
              return "orange"
            }
          } else{
            if (finished){
              return "green"
            }
            else{
              return "orange"
            }
          }
        default:
          return "white";
      }
    },
    getNameState(state, finished) {
      return this.getModeratedOperationText(state, finished, "state");
    },
    getUserfriendlyNameState(state, finished) {
      return this.getModeratedOperationText(state, finished, "userfriendly");
    },
    getFormName(name) {
      if (name !== undefined) {
        return this.$t("forms.titles." + name);
      } else {
        return "";
      }
    },
    getTimeLocale() {
      const locale = (this.$i18n && this.$i18n.locale) || "es";
      switch (locale) {
        case "gl":
          return "gl-ES";
        case "en":
          return "en-US";
        case "es":
        default:
          return "es-ES";
      }
    },
    getStartOfDay(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    getStartOfWeek(date) {
      const startOfDay = this.getStartOfDay(date);
      const day = startOfDay.getDay();
      const diffToMonday = day === 0 ? 6 : day - 1;
      startOfDay.setDate(startOfDay.getDate() - diffToMonday);
      return startOfDay;
    },
    getDayPeriod(date) {
      const hour = date.getHours();
      if (hour < 12) {
        return "morning";
      }
      if (hour < 20) {
        return "afternoon";
      }
      return "night";
    },
    getLocalizedWeekday(date) {
      return new Intl.DateTimeFormat(this.getTimeLocale(), {
        weekday: "long"
      }).format(date);
    },

    timeDifference(previous) {
      const msPerMinute = 60 * 1000;
      const msPerHour = msPerMinute * 60;
      const msPerDay = msPerHour * 24;
      const now = new Date();
      const elapsed = now - previous;
      const dayDifference = Math.round(
        (this.getStartOfDay(now) - this.getStartOfDay(previous)) / msPerDay
      );
      const sameWeek =
        this.getStartOfWeek(now).getTime() ===
        this.getStartOfWeek(previous).getTime();
      const monthDifference = Math.floor(dayDifference / 30);
      const yearDifference = Math.floor(dayDifference / 365);

      if (elapsed < msPerMinute) {
        return this.$t("time.seconds", { number: Math.round(elapsed / 1000) });
      } else if (elapsed < msPerHour) {
        return this.$t("time.minutes", {
          number: Math.round(elapsed / msPerMinute)
        });
      } else if (dayDifference === 0) {
        return this.$t("time.hours", {
          number: Math.round(elapsed / msPerHour)
        });
      } else if (dayDifference === 1) {
        return this.$t(`time.yesterday_${this.getDayPeriod(previous)}`);
      } else if (dayDifference < 7) {
        const key = sameWeek ? "time.weekday" : "time.last_weekday";
        return this.$t(key, {
          weekday: this.getLocalizedWeekday(previous)
        });
      } else if (dayDifference === 7) {
        return this.$t("time.one_week");
      } else if (dayDifference < 14) {
        return this.$t("time.more_than_one_week");
      } else if (dayDifference < 21) {
        return this.$t("time.more_than_two_weeks");
      } else if (dayDifference < 28) {
        return this.$t("time.more_than_three_weeks");
      } else if (monthDifference <= 1) {
        return this.$t("time.more_than_one_month");
      } else if (monthDifference === 2) {
        return this.$t("time.more_than_two_months");
      } else if (monthDifference === 3) {
        return this.$t("time.more_than_three_months");
      } else if (monthDifference === 4) {
        return this.$t("time.more_than_four_months");
      } else if (monthDifference === 5) {
        return this.$t("time.more_than_five_months");
      } else if (monthDifference < 12) {
        return this.$t("time.more_than_months", {
          number: monthDifference
        });
      } else if (yearDifference <= 1) {
        return this.$t("time.more_than_one_year");
      }
      return this.$t("time.more_than_years", {
        number: yearDifference
      });
    },

    getAuthorizeFormsList() {
      let path = this.$store.state.endpoint + "/utils/authorizeFormsList";
      axios
        .get(path)
        .then(response => {
          this.authorizeFormList = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
